window.SMTX.InstantOrderQuote = (function () {
  if ($('.PlaceInstantOrder').length < 1) {
    return false;
  }

  var API_BASE = '/api'; // http://dev.hub2.itcraftlab.com/api/instantquote/v1';
  var languages,
    languageTags = [],
    languageToTagify,
    subjects,
    quoteLead = {},
    calculatedQuote,
    packageLabels = {
      premium: 'Premium package',
      pro: 'Professional package',
      economy: 'Economy package',
    },
    translationMinWords = 6,
    translationMinCharacters = 50,
    // Normal Loader with a spinner
    loader = {
      message: '<img src="/static/icons/spinner.svg" class="blockUI__spinner fixed-center" width="64" height="64" />',
      centerY: false,
      centerX: false,
      css: {
        position: 'fixed',
        margin: 'auto',
      },
      overlayCSS: {
        background: '#fff',
        opacity: 0.6,
      },
    },
    calcDate, // Used for time comparison when loading calculations
    calcMinTime = 3000, // Minimum time in milliseconds for calcLoader to be displayed
    // Specific calculation Loader
    calcLoader = {
      message:
        '<div class="blockUI__calculation fixed-center">' +
        '<img src="/static/images/iq_calculating_loader.gif" class="blockUI__calculation__image" width="600" height="600" />' +
        '<p class=blockUI__calculation__text">' +
        window.SMTX.iq.calculating_price_loader_text +
        '</p>' +
        '</div>',
      centerY: false,
      centerX: false,
      css: {
        position: 'fixed',
        margin: 'auto',
      },
      overlayCSS: {
        background: '#fff',
        opacity: 1,
      },
    };

  var init = function () {
    if (!$('.PlaceInstantOrder').length) {
      return;
    }

    if ($('.PlaceInstantOrder').length < 1) {
      return false;
    }

    // Reset blockUI default css
    $.blockUI.defaults.css = {};

    // Setup handlers
    $('.go-to-step').on('click', stepMenuLink);

    // Module specific form submit
    $('.PlaceInstantOrder--module .go-to-step').on('click', function (e) {
      $(this).parents('form').submit();
    });

    // Step1 Tagify - setup
    var tagifyOptions = {
      whitelist: [], // Is populated in languagesLoaded
      dropdown: {
        enabled: 0, // Shows dropdown instantly
        maxItems: 300, // Show all languages in dropdown
      },
      skipInvalid: true, // Don't show invalid tags
      delimiters: ';', // Comma causes issues, use semicolon instead
      remove: step1.checkIfLanguagesAreChosen,
      add: step1.checkIfLanguagesAreChosen,
    };
    languageToTagify = new Tagify($('input#to-language')[0], tagifyOptions);

    // Step1 Tagify - handlers
    //$('select#from-language').on('change', step1.checkIfLanguagesAreChosen);
    $('select#from-language').on('change', step1.fromLanguageChanged);
    languageToTagify.on('add', step1.checkIfLanguagesAreChosen);
    languageToTagify.on('remove', step1.checkIfLanguagesAreChosen);
    languageToTagify.on('edit', step1.checkIfLanguagesAreChosen);
    languageToTagify.on('blur', step1.checkIfLanguagesAreChosen);
    $('select#from-language').on('change', step1.checkIfLanguagesAreChosen);

    // Step2 handlers
    $('form.email_form, form.upload_file_form, form.user_details').on('submit', function (e) {
      e.preventDefault();
    });
    $('input#quote-email').on('keyup', step2.onEmailInputChange);
    $('.add-email-lead').on('click', step2.addEmailLead);
    $('select#quote-subject').on('change', step2.subjectChosen);
    $('input#quote-upload').on('change', step2.onUploadFileChange);
    $('.quote-upload-submit').on('click', step2.uploadFiles);
    $('input#quote-word-count').on('input blur paste', step2.onQuoteWordCountInputChange);
    $('input#quote-word-count').on('keyup', step2.onQuoteWordCountKeyUp);
    $('textarea#quote-text').on('input blur paste', step2.onQuoteTextInputChange);
    // When translation tabs are changed, double check if button should be clickable
    $('#quote-translation-types').on('change.zf.tabs', step2.checkIfWeCanCalculatePrice);

    // Step3 handlers
    $(document).on('click', '.order-package', function (e) {
      step3.changePackage(e, this);
    });
    $(document).on('change', '.order-package input.quote-package, .order-package input.switch-input', function (e) {
      step3.changePackage(e, this);
    });
    $('.order-package input.switch-input').prop('checked', false); // Always toggle of express delivery on reload
    $(document).on('click', '.order-package .button--order', function (e) {
      e.preventDefault();
      step3.changePackage(e, this); // Make sure we catch a package before continuing

      // Update menu with package details
      updateMenu('packageChosen', {
        text: quoteLead.package.label,
      });

      // Validate input field for email
      $('form.user_details').foundation('validateInput', $('input[name="email"]'));

      showStep(4);
    });

    // Step 4 handlers
    $('.newsletter_signup_label').on('click', step4.toggleNewsletter);

    // Set inactive states
    $('.Step2Form__step--inactive select, .Step2Form__step--inactive input', document).prop('disabled', true);

    // Start getting api-data we need
    blockUI(loader);

    // Check if we've been passed some data from the stand-alone module
    if (window.fromLang !== undefined && window.toLang !== undefined) {
      quoteLead.fromLang = window.fromLang;

      // Populate both input and quoteLead.toLang, quoteLead.toLang will be properly set up later in languagesLoaded
      $('input#to-language').val(window.toLang);
      quoteLead.toLang = JSON.parse(window.toLang);

      showStep(2);
    } else if (window.SMTX.iq.default_from_lang_id !== undefined) {
      quoteLead.fromLang = window.SMTX.iq.default_from_lang_id;
    }

    apiCalls.getLanguages();
    apiCalls.getSubjects();

    setTimeout(function () {
      unblockUI();
    }, 2500);

    // GO TO STEP 2, dev hack!!!!!
    // setTimeout(function () {
    //   $('input#quote-email').val('test@test.com');
    //  // activateStep(2);
    //   showStep(2);
    //   $('.Step2Form__step--inactive select, .Step2Form__step--inactive input', document).prop('disabled', false);
    //   $('.Step2Form__step--inactive').removeClass('Step2Form__step--inactive');
    //   step2.fileUploadReset();
    //   scrollToPos($('.Step2Form__step--choose-translation-type').offset().top - $('.top-menu').outerHeight() - 25);
    //   unblockUI();
    // }, 50);
    //END dev hack

    $('#quote-subject').on('change', function () {
      if ($(this).val()) {
        $(this).removeClass('is-invalid-input');
      }
    });
  };

  // Gets all available languages
  var apiCalls = {
    getLanguages: function () {
      $.get(API_BASE + '/languages?country_code=' + window.SMTX.iq.country_code, {}, apiCallbacks.languagesLoaded);
    },
    // Get Subjects for Step2
    getSubjects: function () {
      $.get(API_BASE + '/subjects?country_code=' + window.SMTX.iq.country_code, {}, apiCallbacks.subjectsLoaded);
    },
    postLead: function (data) {
      // Validate so we're only posting the lead once
      if (!quoteLead.isPostingLead) {
        quoteLead.isPostingLead = true;

        // Remove login-button
        $('.Step2Form__email-exists.Step2Form__email-exists--show').removeClass('Step2Form__email-exists--show');

        // Post email lead
        $.ajax({
          type: 'POST',
          dataType: 'json',
          url: API_BASE + '/leads',
          data: {
            country_code: window.SMTX.iq.country_code,
            email: data.quoteEmail,
            order_details: {
              language_from: data.fromLang,
              languages_to: data.toLang,
            },
          },
          success: step2.postLeadSuccess,
          error: step2.postLeadError,
        });
      }
    },
    uploadFile: function (fileUploadData) {
      blockUI(loader);
      //var fileUploadData = new FormData($('form.upload_file_form')[0]);
      //var API_BASE = '/api';
      $.ajax({
        url: API_BASE + '/files',
        type: 'POST',
        data: fileUploadData,
        cache: false,
        contentType: false,
        enctype: 'multipart/form-data',
        processData: false,
        error: step2.fileUploadError,
        success: step2.fileUploadSuccess,
      });
    },
    calculatePrice: function () {
      // Post quote and get prices
      var calcData = {
        country_code: window.SMTX.iq.country_code, // string - (ISO Country code) - required,
        lead_id: quoteLead.id, // integer - (Lead ID) - required,
        languages_to: quoteLead.toLang,
        language_from: quoteLead.fromLang, // integer - (Language ID) - required,
        // "word_count":  integer - (Word count) - optional,
        // "text": text - (Text to translate) - optional
      };

      // Determine if we need to add word_count or text to calc data
      var translationType = step2.getTranslationType();
      if (translationType == 2) {
        quoteLead.word_count = $('input#quote-word-count').val();
        calcData.word_count = quoteLead.word_count;
        updateMenu('translationContent', {
          word_count: quoteLead.word_count,
        });
      } else if (translationType == 3) {
        quoteLead.text = $('textarea#quote-text').val();
        calcData.text = $('textarea#quote-text').val();
      } else {
        updateMenu('translationContent', {
          fileupload: 1,
        }); // Should be x amount of files
      }

      blockUI(calcLoader);
      calcDate = new Date();
      $.post(API_BASE + '/calculate', calcData, apiCallbacks.receivedQuote);
    },
    sendOrder: function () {
      // Send final order
      var orderData = {
        lead_id: quoteLead.id,
        order_details: {
          language_from: quoteLead.fromLang,
          languages_to: quoteLead.toLang,
          subject_id: quoteLead.subjectId,
          // "package": capitalizeWord(quoteLead.package.name),
          // "delivery": quoteLead.package.type,
          // "days_to_end": quoteLead.package.days_to_end,
          // "cost": quoteLead.package.cost + ' ' + calculatedQuote.currency.iso,
        },
        user_details: {
          first_name: $('form.user_details input[name="first_name"]').val(),
          last_name: $('form.user_details input[name="last_name"]').val(),
          email: $('form.user_details input[name="email"]').val(),
          company: $('form.user_details input[name="company"]').val(),
          phone: $('form.user_details input[name="phone"]').val(),
          newsletter: $('form.user_details input[name="newsletter_signup"]').is(':checked') ? 1 : 0, // Passing 1 and 0 instead of true/false
          // password: $('form.user_details input[name="password"]').val(),
          // password_confirmation: $('form.user_details input[name="password"]').val()
        },
      };

      // check if org_nr is filled, API error on empty string ???
      var org_nr = $.trim($('form.user_details input[name="org_nr"]').val());
      if (org_nr !== '') {
        orderData.user_details.org_nr = org_nr;
      }

      // Check if API has returned any packages or just a user message
      if (quoteLead.hasNoPrice == null) {
        orderData.order_details.package = capitalizeWord(quoteLead.package.name);
        orderData.order_details.delivery = quoteLead.package.type;
        orderData.order_details.days_to_end = quoteLead.package.days_to_end;
        orderData.order_details.price = quoteLead.package.cost + ' ' + calculatedQuote.currency.iso;
      }

      // Check if user typed instructions
      var instructions = $.trim($('form.user_details textarea[name="instructions"]').val());
      if (instructions !== '') {
        orderData.order_details.instructions = instructions;
      }

      //log(orderData);

      // return false;

      // See if we add phone
      var phone_val = $('form.user_details input[name="phone"]').val();
      if (phone_val.length) {
        orderData.user_details.phone = phone_val;
      }

      // Determine if word_count (2) or text (3), add to form
      // ( FileUpload is never added to the orderForm )
      if (quoteLead.translationType == 2) {
        orderData.order_details.word_count = quoteLead.word_count;
      } else if (quoteLead.translationType == 3) {
        orderData.order_details.text = quoteLead.text;
      }

      blockUI(loader);
      $.ajax({
        url: API_BASE + '/order',
        type: 'POST',
        data: orderData,
        success: apiCallbacks.orderConfirmation,
        error: apiCallbacks.orderError,
      });
    },
  };

  var apiCallbacks = {
    // Step1 - Load all languages
    languagesLoaded: function (e) {
      // Set global data
      languages = e;

      // Populate to select box
      $('select#from-language').html('');

      // Loop all languages
      for (var i = 0, il = languages.length; i < il; i++) {
        // Create language nodes
        $('select#from-language').append(
          '<option value="' +
            languages[i].id +
            '"' +
            // Check Swedish by default if no module language data exists, otherwise select the correct from-language
            ((languages[i].code == 'sv-SE' && quoteLead.fromLang === undefined) ||
            (quoteLead.fromLang !== undefined && languages[i].id == quoteLead.fromLang)
              ? ' selected="selected"'
              : '') +
            '>' + // Preselect Swedish
            languages[i].name + // Name visible in dropdown
            '</option>'
        );

        // Setup to-language - Populate languageTags with correct format
        if (
          (languages[i].code == 'sv-SE' && quoteLead.fromLang === undefined) ||
          (quoteLead.fromLang !== undefined && languages[i].id == quoteLead.fromLang)
        ) {
          // avtive lang?
        } else {
          languageTags.push({
            code: languages[i].code,
            id: languages[i].id,
            name: languages[i].name, // Keep original naming in case other value is used
            value: languages[i].name,
          });
        }
      }

      // Add language tags to tagify
      languageToTagify.settings.whitelist = languageTags;
      languageToTagify.settings.enforceWhitelist = true; // Only allow language tags, no text-tags

      // Check if we have been passed languages to translate
      if (quoteLead.toLang !== undefined) {
        // Add tags to tagify
        languageToTagify.addTags(quoteLead.toLang);
      }

      // Check if some input is already in there from previous session
      step1.checkIfLanguagesAreChosen();

      unblockUI();
    },
    // Step2 - Subjects loaded
    subjectsLoaded: function (e) {
      // Set global data
      subjects = e;

      // Populate to select box
      $('select#quote-subject').html('');

      $('select#quote-subject').append(
        '<option value="" disabled selected>' + window.SMTX.iq.choose_subject_placeholder + '</option>'
      );
      // Loop subjects
      for (var i = 0, il = subjects.length; i < il; i++) {
        // Create and add subjects to select box
        $('select#quote-subject').append(
          '<option value="' +
            subjects[i].id +
            '">' +
            //((i == 0) ? ' selected="selected"' : '') + '>' + // Preselect first subject
            subjects[i].name + // Name visible in dropdown
            '</option>'
        );
      }

      // Remove ui blocking class
      $('.Step2Form__step--choose-translation-type').removeClass('Step2Form__step--loading');

      // Prefill subject to quoteLead
      step2.subjectChosen();
    },
    // Received prices
    receivedQuote: function (e) {
      var timeoutTime = 0;
      var currentDate = new Date();
      var elapsedTime = Math.abs(calcDate - currentDate);
      var milliSecondsLeft = calcMinTime - elapsedTime; // See if we have time left that we need to wait

      // If we have time left to wait, add it to timeoutTime
      if (milliSecondsLeft > 0) {
        timeoutTime = milliSecondsLeft;
      }

      // Executes instantly unless we need to wait longer
      setTimeout(function () {
        step4.hideMessage();
        quoteLead.hasNoPrice = null;

        if (e.currency != undefined && e.packages != undefined) {
          // Populate step3 with package info
          calculatedQuote = e;
          step3.populatePackages();

          // Always add word_count if it exists

          if (e.word_count !== undefined) {
            quoteLead.word_count = e.word_count;
            updateMenu('translationContent', {
              word_count: e.word_count,
            });
          }

          var translationType = step2.getTranslationType();

          // Check if word_count
          if (translationType == 2) {
            // Add request class to change "order" to "request"
            $('.PlaceInstantOrder').addClass('PlaceInstantOrder--request');
          } else {
            $('.PlaceInstantOrder').removeClass('PlaceInstantOrder--request');
          }
          // Unblock ui and display packages
          unblockUI();
          activateStep(3);
        } else if (e.message !== undefined) {
          // cannot leave price
          step4.showMessage(e.message);
          quoteLead.hasNoPrice = true;

          unblockUI();
          activateStep(4);
          // log("Calculate message:");
          //log(e.message);
        }
      }, timeoutTime);
    },
    orderConfirmation: function (data, textStatus, xhr) {
      // Show Thank-You-Page
      unblockUI();
      activateStep(5);

      var formHandler;
      var data;
      var newsletter = $('form.user_details input[name="newsletter_signup"]').is(':checked') ? true : '';

      if (window.SMTX.PardotTracker) {
        formHandler = 'l/848143/2021-04-01/p4vsn';
        data = {
          email: quoteLead.email,
          Marketing_Language: window.SMTX.iq.pardot_marketing_language,
          Instant_Quote_Product_Interest: 'Translation',
          Has_Ordered: true,
          GDPR_Newsletter: newsletter,
        };
        window.SMTX.PardotTracker.track(formHandler, data);
      }
    },
    orderError: function (xhr, textStatus, err) {
      // log('xhr', xhr);
      //console.log('statusText', textStatus);
      //console.log('err', err);
    },
  };

  // Method the sub-menu, allows going between steps
  var stepMenuLink = function (e) {
    e.preventDefault();

    var step = $(this).data('step') ? $(this).data('step') : 1; // Get data-step, or default to 1
    showStep(step);
  };

  var activeStepClass = 'PlaceInstantOrder__steps__step--active';
  var activateStep = function (step) {
    // Get element
    stepElem = $('.PlaceInstantOrder__steps__step[data-step="' + step + '"]');

    stepElem
      .addClass(activeStepClass)
      .siblings('.' + activeStepClass)
      .removeClass(activeStepClass);

    scrollToPos(0);
  };

  var scrollToPos = function ($pos) {
    var scrollEvents = 'scroll mousedown wheel DOMMouseScroll mousewheel keyup touchmove';

    // Reset animated scroll if it's already animating
    $('html, body').stop();
    $('html, body').off(scrollEvents);

    // Scroll to position $pos
    $('html, body').on(scrollEvents, function () {
      $('html, body').stop(); // Stop scrolling if we scroll while scrollTop is animating
    });

    $('html, body').animate({ scrollTop: $pos }, 300, function () {
      $('html, body').off(scrollEvents);
    });
  };

  var validateStep = function (step) {
    // Return false if a step doesn't validate
    if (step > 1) {
      // Validate from langauge select and that we have at least one accurate tag
      if (quoteLead.fromLang == '' || quoteLead.toLang == null || quoteLead.toLang.length < 1) {
        return false;
      }
    }

    if (step > 2) {
      if (!$('#quote-subject').val()) {
        $('#quote-subject').addClass('is-invalid-input');
      }
      // Validate quoteLead.id and translation type
      if (
        quoteLead.id == undefined ||
        !$('#quote-subject').val() ||
        ((quoteLead.word_count == undefined || quoteLead.word_count < translationMinWords) &&
          quoteLead.text.length < translationMinCharacters &&
          (quoteLead.fileUploaded == undefined || !quoteLead.fileUploaded))
      ) {
        return false;
      }
    }

    if (step > 3) {
      // Have they selected a package?
      if ((quoteLead.package == undefined || !quoteLead.package.cost) && quoteLead.hasNoPrice == null) {
        return false;
      }
    }

    if (step > 4) {
      // Determine if user_details form are validating

      $('form.user_details').foundation('validateForm');

      // Check if any fields are invalid
      if ($('.is-invalid-input', 'form.user_details').length) {
        return false;
      }
    }
    return true;
  };

  // Main method for changing which "step" you are on
  var showStep = function (step) {
    // Logic for step activation

    $('.StepsMenu__link', '.StepsMenu--main').removeClass('StepsMenu__link--completed, StepsMenu__link--active');

    // Handle menu
    if (step == 1 || step >= 4) {
      // Hide main menu
      $('.StepsMenu--main').removeClass('StepsMenu--show');
    } else {
      // Show menu for steps 2 to 3
      $('.StepsMenu--main').addClass('StepsMenu--show');
    }

    // Verify step changes
    if (step == 1) {
      // No validation needed
      $('.StepsMenu--main').removeClass('StepsMenu--show');
      activateStep(step);
    } else if (validateStep(step)) {
      // Needs step validation for continuing
      // Always add class when stepping above 1, except for 4
      // Handle menu
      if (step == 1 || step >= 4) {
        // Hide main menu
        $('.StepsMenu--main').removeClass('StepsMenu--show');
      } else {
        // Show menu for steps 2 to 3
        $('.StepsMenu--main').addClass('StepsMenu--show');
      }

      if (step == 2) {
        // Display the menu the first time we move beyond step 1
        $('.StepsMenu__link[data-step="1"]', '.StepsMenu--main').addClass('StepsMenu__link--completed');
        $('.StepsMenu__link[data-step="2"]', '.StepsMenu--main').addClass('StepsMenu__link--active');

        // See if we have some e-mail already in input
        step2.validateEmailLeadButton();

        activateStep(step);
      } else if (step == 3) {
        // Add loading
        // Post to API, wait for response
        $('.StepsMenu__link[data-step="1"], .StepsMenu__link[data-step="2"]', '.StepsMenu--main').addClass(
          'StepsMenu__link--completed'
        );
        $('.StepsMenu__link[data-step="3"]', '.StepsMenu--main').addClass('StepsMenu__link--active');
        apiCalls.calculatePrice();
      } else if (step == 4) {
        // Display form
        activateStep(step);
      } else if (step == 5) {
        // block UI and send order
        blockUI(loader);
        apiCalls.sendOrder();
      }
    }
  };

  var step1 = {
    fromLanguageChanged: function (e) {
      var frLang = $('select#from-language').val();
      languageToTagify.removeAllTags();
      var tempLang = languages;
      languageTags = [];

      //tagify.whitelist = null; // reset current whitelist
      languageToTagify.settings.whitelist = null;
      // Loop all languages
      for (var i = 0, il = tempLang.length; i < il; i++) {
        // Create language nodes
        // Setup to-language - Populate languageTags with correct format

        if (tempLang[i].id + '' !== frLang + '') {
          languageTags.push({
            code: tempLang[i].code,
            id: tempLang[i].id,
            name: tempLang[i].name, // Keep original naming in case other value is used
            value: tempLang[i].name,
          });
        }
      }

      //log(languageTags);
      languageToTagify.settings.whitelist = languageTags;
      //languageToTagify.whitelist = languageTags;
      languageToTagify.settings.enforceWhitelist = true;
      step1.checkIfLanguagesAreChosen();
    },
    checkIfLanguagesAreChosen: function (e) {
      // Check if we have any languages chosen
      quoteLead.fromLang = $('select#from-language').val();
      quoteLead.toLang = [];

      // Format language tags
      for (var i = 0, il = languageToTagify.value.length; i < il; i++) {
        //log("From: " + quoteLead.fromLang + ", To: " + languageToTagify.value[i].id);

        if (quoteLead.fromLang !== languageToTagify.value[i].id) {
          quoteLead.toLang.push(languageToTagify.value[i].id);
        }
      }

      // Update language menu
      updateMenu('fromLang', quoteLead.fromLang);
      updateMenu('toLang', quoteLead.toLang);

      // Toggle button if languages exist
      if (quoteLead.fromLang.length && quoteLead.toLang.length) {
        $('.PlaceInstantOrder__steps__step--step1 .button.go-to-step').removeClass('button--inactive');
      } else {
        $('.PlaceInstantOrder__steps__step--step1 .button.go-to-step').addClass('button--inactive');
      }
    },
  };

  // Step2 - Add email lead
  var step2 = {
    onEmailInputChange: function (e) {
      if (e.keyCode == 13) {
        step2.addEmailLead();
      } else {
        step2.validateEmailLeadButton();
      }
    },
    validateEmailLeadButton: function () {
      // Inputting for email, let's check if it's a correct email
      if (isEmail($('input#quote-email').val())) {
        $('.button.add-email-lead').removeClass('button--inactive');
      } else {
        $('.button.add-email-lead').addClass('button--inactive');
      }
    },
    addEmailLead: function () {
      // Set variables
      quoteLead.email = $('input#quote-email').val();

      // Verify email and languages
      if (isEmail(quoteLead.email) && quoteLead.fromLang.length && quoteLead.toLang.length) {
        // Validated, block UI
        blockUI(loader);

        apiCalls.postLead({
          quoteEmail: quoteLead.email,
          fromLang: quoteLead.fromLang,
          toLang: quoteLead.toLang,
        });
      } else {
        // Display error:  Incorrect email or no languages
      }
    },
    // When select box value is changed, update quoteLead
    subjectChosen: function (e) {
      quoteLead.subjectId = $('select#quote-subject').val();
    },
    onUploadFileChange: function () {
      var translationFiles = $('input#quote-upload').prop('files');
      if (translationFiles.length) {
        $('.button.quote-upload-submit').removeClass('button--inactive');
      } else {
        $('.button.quote-upload-submit').addClass('button--inactive');
      }

      step2.checkIfWeCanCalculatePrice();
    },
    uploadFiles: function () {
      var translationFiles = $('input#quote-upload').prop('files');
      if (translationFiles.length && step2.fileUploadValidation()) {
        // Files are chosen
        // Upload files and verify

        // Create a form instead
        var fileUploadData = new FormData($('form.upload_file_form')[0]);
        // var fileUploadData = $('form.upload_file_form').serialize();

        apiCalls.uploadFile(fileUploadData);
      } else {
        // Display error: No files chosen
      }
    },
    onQuoteWordCountInputChange: function () {
      // Make sure its only numbers
      this.value = Number(this.value.replace(/\D/g, '')); // Cast as Number to avoid leading zeros

      step2.checkIfWeCanCalculatePrice();
    },
    onQuoteWordCountKeyUp: function (e) {
      if (e.keyCode == 13) {
        // Pressed enter, continue to next step
        showStep(3);
      }
    },
    onQuoteTextInputChange: function () {
      step2.checkIfWeCanCalculatePrice();
    },
    postLeadSuccess: function (e) {
      quoteLead.isPostingLead = false;

      var results = e;
      // Display translations detail
      if (results.id !== undefined) {
        // Got a lead id, continue
        quoteLead.id = results.id;

        // Make inactive form-step enabled
        $('.Step2Form__step--inactive select, .Step2Form__step--inactive input', document).prop('disabled', false);
        $('.Step2Form__step--inactive').removeClass('Step2Form__step--inactive');

        // Add lead id to file upload
        $('form.upload_file_form input[name="id"]').val(quoteLead.id);

        step2.fileUploadReset();

        // Add email to form on step4
        $('form.user_details input[name="email"]').val(quoteLead.email);

        scrollToPos($('.Step2Form__step--choose-translation-type').offset().top - $('.top-menu').outerHeight() - 25);

        // Display UI again
        unblockUI();

        var formHandler;
        var data;
        if (window.SMTX.PardotTracker) {
          formHandler = 'l/848143/2021-04-01/p4vsn';
          data = {
            email: quoteLead.email,
            Marketing_Language: window.SMTX.iq.pardot_marketing_language,
            Instant_Quote_Product_Interest: 'Translation',
          };
          window.SMTX.PardotTracker.track(formHandler, data);
        }
      } else {
        // Display error: Don't have an id, can't continue
        // unblockUI(loader);
      }
    },
    postLeadError: function (e) {
      quoteLead.isPostingLead = false;

      var response = JSON.parse(e.responseText);
      log(response);
      if (response.errors.email[0].toLowerCase().indexOf('email has already been taken') >= 0) {
        // Show login button
        $('.Step2Form__email-exists').addClass('Step2Form__email-exists--show');
        unblockUI();
      } else {
        // Display error:  Could not create lead
        // unblockUI(loader);
      }
    },
    fileUploadReset: function () {
      // Reset fileUpload
      $('#quote-upload').val(''); // Remove any previously added files
      quoteLead.fileUploaded = false;
      step2.checkIfWeCanCalculatePrice();
      $('.translation-type__fileUpload.button-wrapper').removeClass('hide');
      $('.translation-type__fileUpload-completed').addClass('hide');
    },
    fileUploadValidation: function () {
      var max_total_files = 5;
      var files = $('#quote-upload').prop('files');
      if (files.length > 0 && files.length <= max_total_files) {
        var maxFileSize = 100 * 1024;
        for (var i = 0; i < files.length; i++) {
          var fileSize = files.item(i).size;
          var fileSizeKb = Math.round(fileSize / 1024);

          // Check if file is too large
          if (fileSizeKb >= maxFileSize) {
            alert('Your file is too large. Please select a file less than 100mb');
            step2.fileUploadReset();
            return false;
          }
        }
      } else {
        alert('Too many files. You may only upload five files.');
        step2.fileUploadReset();
        return false;
      }

      return true;
    },
    fileUploadError: function (xhr, textStatus, err) {
      //console.log('xhr', xhr);
      //console.log('statusText', textStatus);
      //console.log('err', err);
      alert('Something went wrong uploading your file(s).');
      unblockUI();
    },
    fileUploadSuccess: function (data, textStatus, xhr) {
      if (typeof data == 'string') {
        data = JSON.parse(data);
      }

      if (data.error === undefined && data.message == 'Files successfully saved') {
        // console.log('data', data);
        // console.log('textStatus', textStatus);
        // console.log('xhr', xhr);
        quoteLead.fileUploaded = true;
        step2.hideFileUpload();
        step2.checkIfWeCanCalculatePrice();
        unblockUI();
      } else {
        // Display error: Something went wrong with the file upload
        //console.log('data', data);
        //console.log(data.message);
        //console.log('textStatus', textStatus);
        //console.log('xhr', xhr);
        alert('Something went wrong uploading your file(s).');
        unblockUI();
      }
    },
    hideFileUpload: function () {
      $('.translation-type__fileUpload-completed').removeClass('hide');
      $('.translation-type__fileUpload.button-wrapper').addClass('hide');
    },
    getTranslationType: function () {
      return Number($('.translation-type.tabs-panel.is-active').data('translation-type'));
    },
    checkIfWeCanCalculatePrice: function () {
      quoteLead.translationType = step2.getTranslationType();
      quoteLead.word_count = $('input#quote-word-count').val();
      quoteLead.text = $('textarea#quote-text').val();

      var calcButton = $('.PlaceInstantOrder__steps__step--step2 .button.go-to-step');

      switch (quoteLead.translationType) {
        case 1:
          if (quoteLead.fileUploaded) {
            calcButton.removeClass('button--inactive');
          } else {
            calcButton.addClass('button--inactive');
          }
          break;
        case 2:
          if (Number(quoteLead.word_count) > translationMinWords) {
            calcButton.removeClass('button--inactive');
          } else {
            calcButton.addClass('button--inactive');
          }
          break;
        case 3:
          if (quoteLead.text.length > translationMinCharacters) {
            calcButton.removeClass('button--inactive');
          } else {
            calcButton.addClass('button--inactive');
          }
          break;
        default:
          break;
      }
      // fileUpload : quoteLead.fileUploaded

      // Wordcount: > 6

      // Add text: > 50 characters
    },
  };

  var step3 = {
    packageElems: [
      {
        elem: $('.order-package--premium'),
        type: 'premium',
      },
      {
        elem: $('.order-package--professional'),
        type: 'pro',
      },
      {
        elem: $('.order-package--economy'),
        type: 'economy',
      },
    ],
    populatePackageWithData: function (elem, data) {
      $('input.default', elem).attr('value', data.general.price).data('days-to-end', data.general.days_to_end);
      $('input.express', elem).attr('value', data.express.price).data('days-to-end', data.express.days_to_end);
      if ($('input.switch-input', elem).prop('checked')) {
        $('.order-package__price', elem).text(data.express.price);
      } else {
        $('.order-package__price', elem).text(data.general.price);
      }
      $('.order-package__currency', elem).text(calculatedQuote.currency.iso);
      $('.order-package__default-delivery__days', elem).text(data.general.days_to_end);

      $('.order-package__express-delivery__days', elem).text(data.express.days_to_end);
    },
    populatePackages: function () {
      var packages = {
        premium: calculatedQuote.packages[packageLabels.premium],
        pro: calculatedQuote.packages[packageLabels.pro],
        economy: calculatedQuote.packages[packageLabels.economy],
      };
      var packageElems = step3.packageElems;

      // If quote is based on plain text
      if (calculatedQuote.word_count !== undefined) {
        quoteLead.word_count = calculatedQuote.word_count;
      }

      // Loop through packageElems and populate with fetched data
      for (var i = 0, il = packageElems.length; i < il; i++) {
        var elem = packageElems[i].elem;
        var data = packages[packageElems[i].type];

        step3.populatePackageWithData(elem, data);
      }
    },
    changePackage: function (e, _this) {
      // If it's the switch input, select the parent order-package
      if ($(_this).is('input') || !$(_this).hasClass('order-package')) {
        _this = $(_this).parents('.order-package');
      }

      $(_this).addClass('order-package--active').siblings().removeClass('order-package--active');

      var package = $(_this).hasClass('order-package') ? $(_this) : $(_this).parents('.order-package');
      var package_express = $('input.switch-input', package).prop('checked');
      var package_cost, delivery_time;

      // Check if express or default
      if (package_express) {
        $('input.express', package).prop('checked', true);
        package_cost = $('input.express', package).val();
        delivery_time = $('input.express', package).data('days-to-end');
      } else {
        $('input.default', package).prop('checked', true);
        package_cost = $('input.default', package).val();
        delivery_time = $('input.default', package).data('days-to-end');
      }

      // debugger;
      // Assign attrs to quoteLead
      quoteLead.package = {
        name: package.data('package-name'), // Get economy, premium, professional etc
        type: package_express ? 'express' : 'ordinary',
        cost: package_cost,
        days_to_end: delivery_time,
      };
      quoteLead.package.label =
        capitalizeWord(quoteLead.package.name) +
        ' - ' +
        getDeliveryStringByType(quoteLead.package.type) +
        ' - ' +
        quoteLead.package.cost +
        calculatedQuote.currency.iso;

      $('.order-package__price', package).text(package_cost);
    },
  };

  var getDeliveryStringByType = function (type) {
    switch (type) {
      case 'express':
        return window.SMTX.iq.express_delivery_string;
        break;
      case 'ordinary':
        return window.SMTX.iq.ordinary_delivery_string;
        break;
      default:
        return '';
    }
  };

  var step4 = {
    toggleNewsletter: function (e) {
      // Toggle newsletter signup
      $('input.newsletter_signup').prop('checked', !$('input.newsletter_signup').prop('checked'));
    },
    showMessage: function (msg) {
      $('.PlaceInstantOrder__order').addClass('has-no-price');
      $('.PlaceInstantOrder__order .StepsMenu--order_form').addClass('has-user-message');
      $('.PlaceInstantOrder__order .user-message').show();
      $('.PlaceInstantOrder__order .user-message .text').text(msg);
      //$('.PlaceInstantOrder__steps-menu__link[data-step="3"]').hide();
    },
    hideMessage: function () {
      $('.PlaceInstantOrder__order').removeClass('has-no-price');
      $('.PlaceInstantOrder__order .StepsMenu--order_form').removeClass('has-user-message');
      $('.PlaceInstantOrder__order .user-message').hide();
    },
  };

  // Misc utils

  var getLanguageChars = function (val) {
    for (var i = 0, il = languages.length; i < il; i++) {
      if (languages[i].id == val) {
        return languages[i].code.slice(-2);
      }
    }
    return '';
  };

  var getLanguageName = function (val) {
    for (var i = 0, il = languages.length; i < il; i++) {
      if (languages[i].id == val) {
        return languages[i].name;
      }
    }
    return '';
  };

  var updateMenu = function (key, val) {
    var lang = '';
    // Preformat languages if needed
    if (key == 'fromLang' || key == 'toLang') {
      // Check if array or not
      if (!Array.isArray(val)) {
        lang = getLanguageName(val);
      } else {
        // Loop nested language array
        for (var i = 0, il = val.length; i < il; i++) {
          lang += getLanguageName(val[i]) + ', ';
        }
      }

      // Get rid of trailing comma if needed
      lang = lang.trim();
      if (lang.slice(-1) === ',') {
        lang = lang.slice(0, -1);
      }
    }

    // Update menu text
    switch (key) {
      case 'fromLang':
        $('.StepsMenu__from').text(lang);
        break;
      case 'toLang':
        $('.StepsMenu__to').text(lang);
        break;
      case 'translationContent':
        if (val.word_count !== undefined) {
          $('.StepsMenu__quote-info').text(val.word_count + ' ' + window.SMTX.iq.words_string);
        } else if (val.text !== undefined) {
          $('.StepsMenu__quote-info').text(val.text + ' ' + window.SMTX.iq.chars_count_string);
        } else if (val.fileupload !== undefined) {
          $('.StepsMenu__quote-info').text(window.SMTX.iq.uploaded_file_string);
        }
        break;
      case 'packageChosen':
        $('.StepsMenu__package-info').text(val.text);
        break;
      default:
        break;
    }
  };

  var blockUI = function (settings) {
    // $('.PlaceInstantOrder').block(settings);

    $.blockUI(settings);
  };

  var unblockUI = function () {
    // $('.PlaceInstantOrder').unblock();
    $.unblockUI();
  };

  init();

  window.blockUI = blockUI;

  return {
    quoteLead: quoteLead,
  };
})();
